export function loadJSONP(url, firstParam) {
    var prop = '_' + Math.floor((Math.random() * 100000000) + 1);
    var script = document.createElement("script");
    function withCleanUp(r) {
        return (x) => {
            window[prop] = null;
            document.head.removeChild(script);
            r(x);
        }
    }
    return new Promise((resolve, reject) => {
        window[prop] = withCleanUp(resolve);
        script.onerror = withCleanUp(reject);
        // setTimeout(script.onerror, 5000); might be advisable

        if (firstParam) {
            script.src = url + "?callback=" + prop;
        } else {
            script.src = url + "&callback=" + prop;
        }
        document.head.appendChild(script);
    });
}